import { SortingValue } from 'shared/lib/components/controls/sorting/sortingControl';
import { sortBy } from 'lodash-es';
import { makeAutoObservable } from 'mobx';
import { FileModel } from 'entities/file/model/fileModel';
import { TableModel } from 'entities/table/model/tableModel';
import moment from 'moment';

export class FilesAndTablesHelper {
  private _files: FileModel[] | null;
  private _tables: TableModel[] | null;
  private _sort?: SortingValue;

  constructor({
    files,
    tables,
    sort,
  }: {
    files: FileModel[] | null;
    tables: TableModel[] | null;
    sort: SortingValue;
  }) {
    this._files = files;
    this._tables = tables;
    this._sort = sort;
    makeAutoObservable(this);
  }

  public get content() {
    if (this._files && this._tables) {
      return sortBy(
        [...(this._files || []), ...(this._tables || [])],
        (item1) => {
          switch (this._sort) {
            case SortingValue.UPDATING_INC:
              return moment(item1.data?.last_change_date).unix();
            case SortingValue.UPDATING_DEC:
              return -moment(item1.data?.last_change_date).unix();
            case SortingValue.CREATING_INC:
              return moment(item1.data?.add_date).unix();
            case SortingValue.CREATING_DEC:
              return -moment(item1.data?.add_date).unix();
            case SortingValue.FAVORITING_INC:
              return moment(item1.data?.add_date_to_favorite).unix();
            case SortingValue.FAVORITING_DEC:
              return -moment(item1.data?.add_date_to_favorite).unix();
          }
        }
      );
    }

    return null;
  }

  public get isNotFound() {
    return (
      this._files !== null &&
      this._tables !== null &&
      this._tables.length === 0 &&
      this._files.length === 0
    );
  }
  public get isPending() {
    return this._tables === null || this._files === null;
  }
}
